import $ from 'jquery';

$.fn.setNotFound = function (name, breadcrumb) {
  if (breadcrumb) $.setBreadcrumb(breadcrumb, `<i class="fa fa-exclamation-triangle text-danger mr-1"></i>Not Found`);

  let $pane = $(this).closest('.pane-app-main').find('.pane-content');
  const $dt = $pane.find('.dt-container');
  const $form = $pane.find('form');

  if ($dt.length) $pane = $dt.closest('.pane');
  else if ($form.length) $pane = $form.closest('.pane');
  else $pane = false;

  if ($pane)
    $pane.empty().append(`
    <div class="panes panes-centered">
      <div class="pane pane-grow">
        <h1 class="text-center my-0">
          <i class="fa fa-exclamation-triangle fa-lg text-danger align-middle"></i>
          <span>${name} Not Found</span>
        </h1>
      </div>
    </div>
  `);
};
